import styled from 'styled-components';

export const GovNumButtonContainer = styled.div`
  @media (max-width: 512px) {
    margin-left: 8px;
    margin-right: 8px;
  }
  .button {
    width: 100%;
    margin-bottom: 18px;

    & button {
      width: 100%;
      padding: 0;
    }
  }
`;
